<template>
    <!-- 分页部分 -->
    <div class="text-center">
        <ul class="pagination">
            <li :class="{ active: active > 1 }">
                <a href="javascript:;" aria-label="Previous" @click="page(active - 1)">
                    <span aria-hidden="true">&lt;</span>
                </a>
            </li>
            <li v-for="n in pageNum" :class="{ active: active == n }" @click="page(n)">
                <a href="javascript:void(0);" :data-page="n">{{n}}</a>
            </li>
            <li :class="{ active: active < total }">
                <a href="javascript:;" aria-label="Next" :data-page="active" @click="page(active + 1)">
                    <span aria-hidden="true">&gt;</span>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "pagination",
        props: ['total'],
        data(){
            return {
                active: 1
            }
        },
        computed:{
            pageNum(){
                var gap = 2, //两边间隔
                    cur = this.active, //当前活跃
                    all = this.total, //总页数
                    start = 1, //开始位置
                    end = 1; //结束位置
                if(all < 5){ //页数小于5，全部显示
                    start = 1;end = all;
                }else{
                    if(cur - gap <= 0){ //到达起始位置处理
                        start = 1;end = cur + gap + Math.abs(cur - gap) + 1;
                    }else if(cur + gap >= all){//到达结束位置处理
                        start = cur - gap - Math.abs(cur + gap - all);end = cur + 2;
                    }else{//之间处理
                        start = cur - 2;end = cur + 2;
                    }
                }
    			return this.getNums(start,end);
            }
        },
        methods:{
            getNums(start = 1,end = 1){ //获取任意start到end的数组
                return [...(new Array(end+1)).keys()].slice(start,end+1);
    		},
            page(index){
                if(index>0 && index<this.total+1){
                    this.active = index;
                    this.$emit("page",index);
                    window.scrollTo(0,0);
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/common/PagePagination.vue